
// Routing paths
const Path = {
  HOME: "/",
  PRIVACY: '/privacy-policy'
};

export default Path;
